export const SET_CURRENT_COMPANY = 'SET_CURRENT_COMPANY';

export default function setCurrentCompany(payload) {
  return {
    type: SET_CURRENT_COMPANY,
    payload,
  };
}
